import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {
    changeQuestionTab,
    updateQuestionInSurveyAtIdx
} from "../../../../../slices/surveyEditorSlice";
import {validateQuestion} from "../../../../../utils/SurveyValidationUtils";
import {withToastManager} from "react-toast-notifications";
import EditQuestionContent from "./EditQuestionContent";
import EditQuestionLogic from "./EditQuestionLogic";
import ErrorBoundary from "../../../../meta/ErrorBoundary";
import {questionsEditModeMenuTabs} from "../../../../../utils/SurveyUtils";
import LoadingIndicator from "../../../../meta/LoadingIndicator";

function QuestionEditMode(props) {
    const dispatch = useDispatch();

    const menuTabs = questionsEditModeMenuTabs;
    const [tabsMenuIsOpenMobile, setTabsMenuIsOpenMobile] = useState(false);

    const setMenuSelectedTab = (tab) => {
        dispatch(changeQuestionTab({idx: props.idx, tab: tab}));
    };

    const handleEditModeSave = () => {
        const {questionData, idx} = props;

        if(props.isSurveySaving) return;

        let newQuestionData = JSON.parse(JSON.stringify(questionData));
        newQuestionData.isInvalidQuestion = !validateQuestion(newQuestionData);
        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));

        if (newQuestionData.isInvalidQuestion) {
            dispatch(changeQuestionTab({idx: props.idx, tab: questionsEditModeMenuTabs[0]}));
            return;
        }

        const displayToastAfterSave = () => {
            props.toastManager.add(`${newQuestionData.id} was saved and added to your survey.`, {
                appearance: 'success'
            });
        };
        props.handleSurveySave(displayToastAfterSave);
    };

    const handleTabsMenuToggleMobile = (event) => {
        event.preventDefault();
        setTabsMenuIsOpenMobile(!tabsMenuIsOpenMobile);
    };

    const buildEditMenuHtml = () => {
        const {questionData} = props;
        const menuTabsHtml = menuTabs.map((tab, index) => {
            let key = "menu_tab_item_key_" + tab;
            let tabClassName = "questionaire__builder__question__tabs__item";
            if (tab === questionData.selectedTab) {
                tabClassName = tabClassName + " questionaire__builder__question__tabs__item--selected";
            }
            return (
                <a key={key} href="#"
                   className={tabClassName}
                   onClick={(event) => {
                       event.preventDefault();
                       setMenuSelectedTab(tab);
                       setTabsMenuIsOpenMobile(false);
                   }}
                >
                    {tab}
                </a>
            );
        });

        return (
            <div className="questionaire__builder__question__tabs">
                <div onClick={handleTabsMenuToggleMobile} className="questionaire__builder__question__tabs__choice">
                    {questionData.selectedTab}
                </div>
                <div className="questionaire__builder__question__tabs">
                    <div className={"questionaire__builder__question__tabs__items " + (tabsMenuIsOpenMobile ? " questionaire__builder__question__tabs__items--open" : "")} >
                        {menuTabsHtml}
                    </div>
                </div>
            </div>
        );
    };

    const getSelectedTabComponent = () => {
        const {questionData, idx} = props;

        switch (questionData.selectedTab) {
            case questionsEditModeMenuTabs[0]:
                return (
                    <ErrorBoundary boundaryName={"Edit Question Info Tab"}>
                        <EditQuestionContent questionData={questionData} idx={idx}/>
                    </ErrorBoundary>
                );
            case questionsEditModeMenuTabs[1]:
                return (
                    <ErrorBoundary boundaryName={"Edit Question Logic Tab"}>
                        <EditQuestionLogic questionData={questionData} idx={idx}/>
                    </ErrorBoundary>
                );
            default:
                return null;
        }
    };

    const tabsMenu = buildEditMenuHtml();
    const selectedTabComponent = getSelectedTabComponent();

    return (
        <React.Fragment>
            {tabsMenu}
            {selectedTabComponent}
            <div className="cta__wrapp pt-xs">
                {props.isSurveySaving ?
                    (<LoadingIndicator/>)
                    :
                    (
                        <a href="#" onClick={(event) => {
                            event.preventDefault();
                            handleEditModeSave();
                        }} className="cta--normal questionaire__builder__question__action__save">SAVE</a>
                    )
                }
            </div>
        </React.Fragment>
    )
}

export default withToastManager(QuestionEditMode);